import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';
import { buildQueryParams } from '../../utils/object';

export const cropVarietyApi = createApi({
  reducerPath: 'cropVarietyApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),

  tagTypes: ['CropVariety'],
  endpoints: (builder) => ({
    addCropVariety: builder.mutation({
      query: (newCropVariety) => ({
        url: 'crop-varieties',
        method: 'POST',
        body: newCropVariety,
      }),
      invalidatesTags: ['CropVariety'],
    }),

    updateCropVariety: builder.mutation({
      query: ({ id, updatedCropVariety }) => ({
        url: `crop-varieties/${id}`,
        method: 'PUT',
        body: updatedCropVariety,
      }),
      invalidatesTags: ['CropVariety'],
    }),

    deleteCropVariety: builder.mutation({
      query: (id) => ({
        url: `crop-varieties/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CropVariety'],
    }),

    getCropVarietiesByCropId: builder.query({
      query: ({ cropId, page, limit, search } = {}) => ({
        url: `crop-varieties/crop/${cropId}`,
        params: buildQueryParams({ page, limit, search }),
      }),
      providesTags: ['CropVariety'],
    }),

    getCropVarietyUsage: builder.query({
      query: (id) => `crop-varieties/${id}/usage`,
      keepUnusedDataFor: 0,
    }),

    getCropVarietiesByCropIds: builder.query({
      query: ({ cropIds = [] } = {}) => {
        const searchParams = new URLSearchParams();
        cropIds.forEach((cropId) => searchParams.append('crop_ids', cropId));
        return { url: `crop-varieties?${searchParams.toString()}` };
      },
      providesTags: ['CropVariety'],
    }),
  }),
});

export const {
  useAddCropVarietyMutation,
  useUpdateCropVarietyMutation,
  useDeleteCropVarietyMutation,
  useGetCropVarietiesByCropIdQuery,
  useGetCropVarietiesByCropIdsQuery,
  useGetCropVarietyUsageQuery,
} = cropVarietyApi;
